import Request from '../Request';
import EndPoints, { applyPathVariables } from '../EndPoints';
import Methods from '../Methods';
/**
 *
 * @param serviceSchema ServiceSchemaModel
 * @param organisation OrganisationModel
 * @return {Promise<any>|Promise}
 */
export default (function (serviceSchema, organisation) {
    var url = applyPathVariables(EndPoints.SERVICE_SCHEMAS, { organisationId: organisation.id });
    var request = new Request({ method: Methods.POST, url: url, withCredentials: true, data: serviceSchema });
    return request.execute();
});
